import React from 'react';
import PropTypes from 'prop-types';

function Welcome ({ flows, selectFlow }) {
  return (
    <div className='Vetsmith-Welcome-content'>
      <div className='Instructions-body'>
        <div>
          <h1>Welcome!</h1>
          <p style={{ whiteSpace: 'pre-line' }}>You have expressed interest in the below jobs, please complete the required technical assessments to be considered for these jobs</p>
          <div className='flows-list'>
            {flows.map((flow) => (
              <div key={flow.flow_id} onClick={() => selectFlow(flow.flow_id)} >
                <div>
                  <span className="material-icons">stars</span>
                  <span className="flow-name">{flow.flow_name}</span>
                </div>
                <span className="material-icons">chevron_right</span>
              </div>
            ))}
          </div>
        </div>
        <div className="imageHolder">
          <img className='contentimage' src='/images/vetsmith-hero.png' alt='Vetsmith-Instructions' />
        </div>
      </div>
    </div>
  );
}

Welcome.propTypes = {
  flows: PropTypes.array,
  selectFlow: PropTypes.func
};

export default Welcome;
